import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './styles/globals.css'
import App from './App.tsx'
import { initAnalytics, track } from './lib/analytics'

initAnalytics()

window.addEventListener('beforeinstallprompt', () => {
  track('pwa_install_prompt_available')
})
window.addEventListener('appinstalled', () => {
  track('pwa_installed')
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
